/* tslint:disable */
/* eslint-disable */
/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { RequestsToJoinApproveCommand } from '../models';
import { RequestsToJoinCiteCertificationCommand } from '../models';
import { RequestsToJoinDenyCommand } from '../models';
import { RequestsToJoinFetchResponse } from '../models';
import { RequestsToJoinOrganisationAdminCommand } from '../models';
import { RequestsToJoinPendingRequestsResponse } from '../models';
import { RequestsToJoinReviewCertificationResponse } from '../models';
import { RequestsToJoinStaffTypeCommand } from '../models';
import { RequestsToJoinVisitorTypeCommand } from '../models';
import { RequestsToJoinVolunteerApproveCommand } from '../models';
import { RequestsToJoinVolunteerDenyCommand } from '../models';
import { SharedModelsCommandResponse } from '../models';
/**
 * RequestsToJoinApi - axios parameter creator
 * @export
 */
export const RequestsToJoinApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RequestsToJoinApproveCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinApprovePost: async (body?: RequestsToJoinApproveCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/requeststojoin/approve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RequestsToJoinCiteCertificationCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinCitecertificationPost: async (body?: RequestsToJoinCiteCertificationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/requeststojoin/citecertification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RequestsToJoinDenyCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinDenyPost: async (body?: RequestsToJoinDenyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/requeststojoin/deny`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinFetchGet: async (profileId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/requeststojoin/fetch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (profileId !== undefined) {
                localVarQueryParameter['ProfileId'] = profileId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RequestsToJoinOrganisationAdminCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinOrganisationadminPost: async (body?: RequestsToJoinOrganisationAdminCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/requeststojoin/organisationadmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinPendingrequestsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/requeststojoin/pendingrequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinReviewcertificationGet: async (id?: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/requeststojoin/reviewcertification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RequestsToJoinStaffTypeCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinStafftypePost: async (body?: RequestsToJoinStaffTypeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/requeststojoin/stafftype`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RequestsToJoinVisitorTypeCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinVisitortypePost: async (body?: RequestsToJoinVisitorTypeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/requeststojoin/visitortype`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RequestsToJoinVolunteerApproveCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinVolunteerapprovePost: async (body?: RequestsToJoinVolunteerApproveCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/requeststojoin/volunteerapprove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RequestsToJoinVolunteerDenyCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinVolunteerdenyPost: async (body?: RequestsToJoinVolunteerDenyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/requeststojoin/volunteerdeny`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RequestsToJoinApi - functional programming interface
 * @export
 */
export const RequestsToJoinApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RequestsToJoinApproveCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequeststojoinApprovePost(body?: RequestsToJoinApproveCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await RequestsToJoinApiAxiosParamCreator(configuration).apiRequeststojoinApprovePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {RequestsToJoinCiteCertificationCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequeststojoinCitecertificationPost(body?: RequestsToJoinCiteCertificationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await RequestsToJoinApiAxiosParamCreator(configuration).apiRequeststojoinCitecertificationPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {RequestsToJoinDenyCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequeststojoinDenyPost(body?: RequestsToJoinDenyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await RequestsToJoinApiAxiosParamCreator(configuration).apiRequeststojoinDenyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequeststojoinFetchGet(profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestsToJoinFetchResponse>> {
            const localVarAxiosArgs = await RequestsToJoinApiAxiosParamCreator(configuration).apiRequeststojoinFetchGet(profileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {RequestsToJoinOrganisationAdminCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequeststojoinOrganisationadminPost(body?: RequestsToJoinOrganisationAdminCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await RequestsToJoinApiAxiosParamCreator(configuration).apiRequeststojoinOrganisationadminPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequeststojoinPendingrequestsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestsToJoinPendingRequestsResponse>> {
            const localVarAxiosArgs = await RequestsToJoinApiAxiosParamCreator(configuration).apiRequeststojoinPendingrequestsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequeststojoinReviewcertificationGet(id?: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestsToJoinReviewCertificationResponse>> {
            const localVarAxiosArgs = await RequestsToJoinApiAxiosParamCreator(configuration).apiRequeststojoinReviewcertificationGet(id, profileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {RequestsToJoinStaffTypeCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequeststojoinStafftypePost(body?: RequestsToJoinStaffTypeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await RequestsToJoinApiAxiosParamCreator(configuration).apiRequeststojoinStafftypePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {RequestsToJoinVisitorTypeCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequeststojoinVisitortypePost(body?: RequestsToJoinVisitorTypeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await RequestsToJoinApiAxiosParamCreator(configuration).apiRequeststojoinVisitortypePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {RequestsToJoinVolunteerApproveCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequeststojoinVolunteerapprovePost(body?: RequestsToJoinVolunteerApproveCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await RequestsToJoinApiAxiosParamCreator(configuration).apiRequeststojoinVolunteerapprovePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {RequestsToJoinVolunteerDenyCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequeststojoinVolunteerdenyPost(body?: RequestsToJoinVolunteerDenyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await RequestsToJoinApiAxiosParamCreator(configuration).apiRequeststojoinVolunteerdenyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RequestsToJoinApi - factory interface
 * @export
 */
export const RequestsToJoinApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {RequestsToJoinApproveCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinApprovePost(body?: RequestsToJoinApproveCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return RequestsToJoinApiFp(configuration).apiRequeststojoinApprovePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RequestsToJoinCiteCertificationCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinCitecertificationPost(body?: RequestsToJoinCiteCertificationCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return RequestsToJoinApiFp(configuration).apiRequeststojoinCitecertificationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RequestsToJoinDenyCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinDenyPost(body?: RequestsToJoinDenyCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return RequestsToJoinApiFp(configuration).apiRequeststojoinDenyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinFetchGet(profileId?: string, options?: any): AxiosPromise<RequestsToJoinFetchResponse> {
            return RequestsToJoinApiFp(configuration).apiRequeststojoinFetchGet(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RequestsToJoinOrganisationAdminCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinOrganisationadminPost(body?: RequestsToJoinOrganisationAdminCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return RequestsToJoinApiFp(configuration).apiRequeststojoinOrganisationadminPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinPendingrequestsGet(options?: any): AxiosPromise<RequestsToJoinPendingRequestsResponse> {
            return RequestsToJoinApiFp(configuration).apiRequeststojoinPendingrequestsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinReviewcertificationGet(id?: string, profileId?: string, options?: any): AxiosPromise<RequestsToJoinReviewCertificationResponse> {
            return RequestsToJoinApiFp(configuration).apiRequeststojoinReviewcertificationGet(id, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RequestsToJoinStaffTypeCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinStafftypePost(body?: RequestsToJoinStaffTypeCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return RequestsToJoinApiFp(configuration).apiRequeststojoinStafftypePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RequestsToJoinVisitorTypeCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinVisitortypePost(body?: RequestsToJoinVisitorTypeCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return RequestsToJoinApiFp(configuration).apiRequeststojoinVisitortypePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RequestsToJoinVolunteerApproveCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinVolunteerapprovePost(body?: RequestsToJoinVolunteerApproveCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return RequestsToJoinApiFp(configuration).apiRequeststojoinVolunteerapprovePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RequestsToJoinVolunteerDenyCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequeststojoinVolunteerdenyPost(body?: RequestsToJoinVolunteerDenyCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return RequestsToJoinApiFp(configuration).apiRequeststojoinVolunteerdenyPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RequestsToJoinApi - object-oriented interface
 * @export
 * @class RequestsToJoinApi
 * @extends {BaseAPI}
 */
export class RequestsToJoinApi extends BaseAPI {
    /**
     * 
     * @param {RequestsToJoinApproveCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsToJoinApi
     */
    public apiRequeststojoinApprovePost(body?: RequestsToJoinApproveCommand, options?: any) {
        return RequestsToJoinApiFp(this.configuration).apiRequeststojoinApprovePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {RequestsToJoinCiteCertificationCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsToJoinApi
     */
    public apiRequeststojoinCitecertificationPost(body?: RequestsToJoinCiteCertificationCommand, options?: any) {
        return RequestsToJoinApiFp(this.configuration).apiRequeststojoinCitecertificationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {RequestsToJoinDenyCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsToJoinApi
     */
    public apiRequeststojoinDenyPost(body?: RequestsToJoinDenyCommand, options?: any) {
        return RequestsToJoinApiFp(this.configuration).apiRequeststojoinDenyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsToJoinApi
     */
    public apiRequeststojoinFetchGet(profileId?: string, options?: any) {
        return RequestsToJoinApiFp(this.configuration).apiRequeststojoinFetchGet(profileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {RequestsToJoinOrganisationAdminCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsToJoinApi
     */
    public apiRequeststojoinOrganisationadminPost(body?: RequestsToJoinOrganisationAdminCommand, options?: any) {
        return RequestsToJoinApiFp(this.configuration).apiRequeststojoinOrganisationadminPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsToJoinApi
     */
    public apiRequeststojoinPendingrequestsGet(options?: any) {
        return RequestsToJoinApiFp(this.configuration).apiRequeststojoinPendingrequestsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [id] 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsToJoinApi
     */
    public apiRequeststojoinReviewcertificationGet(id?: string, profileId?: string, options?: any) {
        return RequestsToJoinApiFp(this.configuration).apiRequeststojoinReviewcertificationGet(id, profileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {RequestsToJoinStaffTypeCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsToJoinApi
     */
    public apiRequeststojoinStafftypePost(body?: RequestsToJoinStaffTypeCommand, options?: any) {
        return RequestsToJoinApiFp(this.configuration).apiRequeststojoinStafftypePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {RequestsToJoinVisitorTypeCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsToJoinApi
     */
    public apiRequeststojoinVisitortypePost(body?: RequestsToJoinVisitorTypeCommand, options?: any) {
        return RequestsToJoinApiFp(this.configuration).apiRequeststojoinVisitortypePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {RequestsToJoinVolunteerApproveCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsToJoinApi
     */
    public apiRequeststojoinVolunteerapprovePost(body?: RequestsToJoinVolunteerApproveCommand, options?: any) {
        return RequestsToJoinApiFp(this.configuration).apiRequeststojoinVolunteerapprovePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {RequestsToJoinVolunteerDenyCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsToJoinApi
     */
    public apiRequeststojoinVolunteerdenyPost(body?: RequestsToJoinVolunteerDenyCommand, options?: any) {
        return RequestsToJoinApiFp(this.configuration).apiRequeststojoinVolunteerdenyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
